import { UserNameInfoModel } from "core/components/userProfile/userNameInfoModel";
import { EmblaIcons, EmblaIconsType } from "core/emblaIcons";
import { RolleTitelEnum } from "infrastructure/enums/rolleTitelEnum";
import { Localizer } from "infrastructure/localization/localizer";

// Enum ligger også i Logbog og Stamdata:
export enum NotifikationEventTypeEnum {
  KompetenceKlarmeldt = 1,
  KompetenceGodkendt = 2,
  VejlederOprettet = 3,
  VejlederAdgangAendret = 4,
  BrugerNyRolle = 5,
  ForloebKanGodkendes = 6,
  IndsendStpsDokumentation = 7,
  NyhedPubliceret = 8,
  ForloebEvalueringIndsendt = 9,
  AlleKurserIGruppeGodkendt = 10,
  KompetenceKlarmeldingAfvist = 11, //Notifikation til uddannelseslægen, når en bruger afviser klarmelding af en laegekompetence
  KompetenceKlarmeldingFjernet = 12, // Notifikation til uddannelseslægen, når KlarmeldingStatus service fjerner klarmelding af en laegekompetence, fordi den har været klarmeldt i 3 måneder uden godkendelse
  UddannelsesplanGodkendt = 13
}

export const NotifikationEventTypeEnumToTitleString = (eventType: NotifikationEventTypeEnum): string => {
  switch (eventType) {
      case NotifikationEventTypeEnum.KompetenceKlarmeldt:
          return Localizer.notifikationer_KompetenceKlarmeldt_Title();
      case NotifikationEventTypeEnum.KompetenceGodkendt:
          return Localizer.notifikationer_KompetenceGodkendt_Title();
      case NotifikationEventTypeEnum.VejlederOprettet:
          return Localizer.notifikationer_VejlederOprettet_Title();
      case NotifikationEventTypeEnum.VejlederAdgangAendret:
          return Localizer.notifikationer_VejlederAdgangAendret_Title();
      case NotifikationEventTypeEnum.BrugerNyRolle:
          return Localizer.notifikationer_BrugerNyRolle_Title();
      case NotifikationEventTypeEnum.ForloebKanGodkendes:
          return Localizer.notifikationer_ForloebKanGodkendes_Title();
      case NotifikationEventTypeEnum.IndsendStpsDokumentation:
          return Localizer.notifikationer_IndsendStpsDokumentation_Title();
      case NotifikationEventTypeEnum.NyhedPubliceret:
           return Localizer.notifikationer_NyhedPubliceret_Title();
      case NotifikationEventTypeEnum.ForloebEvalueringIndsendt:
          return Localizer.notifikationer_ForloebEvalueringIndsendt_Title();
      case NotifikationEventTypeEnum.AlleKurserIGruppeGodkendt:
          return Localizer.notifikationer_AlleKurserIGruppeGodkendt_Title();
      case NotifikationEventTypeEnum.KompetenceKlarmeldingAfvist:
          return Localizer.notifikationer_KlarmeldingAfvist_Title();
      case NotifikationEventTypeEnum.KompetenceKlarmeldingFjernet:
          return Localizer.notifikationer_KlarmeldingFjernet_Title();
      case NotifikationEventTypeEnum.UddannelsesplanGodkendt:
          return Localizer.notifikationer_UddannelsesplanGodkendt_Title();
      default:
          return Localizer.notifikationer_NotifikationsTypeEnumFallback();
  }
}

export const NotifikationEventTypeEnumToIconName = (eventType: NotifikationEventTypeEnum): EmblaIconsType => {
  switch (eventType) {
      case NotifikationEventTypeEnum.KompetenceKlarmeldt:
      case NotifikationEventTypeEnum.KompetenceGodkendt:
      case NotifikationEventTypeEnum.KompetenceKlarmeldingAfvist:
      case NotifikationEventTypeEnum.KompetenceKlarmeldingFjernet:
          return EmblaIcons.Star;
      case NotifikationEventTypeEnum.VejlederOprettet:
      case NotifikationEventTypeEnum.VejlederAdgangAendret:
          return EmblaIcons.UserGroup;
      case NotifikationEventTypeEnum.BrugerNyRolle:
          return EmblaIcons.User;
      case NotifikationEventTypeEnum.NyhedPubliceret:
          return EmblaIcons.Feed;
      case NotifikationEventTypeEnum.UddannelsesplanGodkendt:
          return EmblaIcons.DialogChat;
      default:
          return EmblaIcons.Notifications;
  }
} //TODO: #12772 - icon for uddannelsesplaner?

export type NotificationAfsenderModel = {
  info?: UserNameInfoModel;
  rolletitelEnum?: RolleTitelEnum;
}

export type NotificationModel = {
  id: string;
  type: NotifikationEventTypeEnum;
  contextId: string;
  message: string;
  erSet: boolean;
  timestamp: Date;
  afsender: NotificationAfsenderModel;
}

export type NotificationEditSeenStatusModel = {
    markAsSeen: boolean;
    notifikationIdList: string[];
}
